import React from 'react';
import { Treemap } from '@visx/hierarchy';
import CapabilityNode from './CapabilityNode';
import {
  CHILD_AREA_BORDER,
  CHILD_AREA_RADIUS,
  CHILD_TILE_GAP,
  buildCapabilityRoot,
} from './capabilityTreemapUtils';

export default function CapabilityChildNodes({
  childAreaX,
  childAreaY,
  childAreaWidth,
  childAreaHeight,
  childCapabilities,
  minLabelWidth,
  minLabelHeight,
  onCapabilityHover,
  onCapabilityLeave,
}) {
  const childRoot = buildCapabilityRoot(childCapabilities);
  const hasChildNodes = childRoot.children?.length > 0;

  if (!hasChildNodes || childAreaWidth <= 0 || childAreaHeight <= 0) {
    return null;
  }

  return (
    <g transform={`translate(${childAreaX}, ${childAreaY})`}>
      <rect
        x={0}
        y={0}
        width={childAreaWidth}
        height={childAreaHeight}
        fill={CHILD_AREA_BORDER}
        stroke="none"
        rx={CHILD_AREA_RADIUS}
      />
      <Treemap
        root={childRoot}
        size={[childAreaWidth, childAreaHeight]}
        padding={CHILD_TILE_GAP}
        round
      >
        {(childTreemap) => (
          <g>
            {childTreemap
              .descendants()
              .filter((node) => !node.children)
              .map((node) => (
                <CapabilityNode
                  key={
                    node.data.id || node.data.name || `${node.x0}-${node.y0}`
                  }
                  node={node}
                  minLabelWidth={minLabelWidth}
                  minLabelHeight={minLabelHeight}
                  onCapabilityHover={onCapabilityHover}
                  onCapabilityLeave={onCapabilityLeave}
                />
              ))}
          </g>
        )}
      </Treemap>
    </g>
  );
}
